<template>
  <div class="help-center-new-details">
    <div class="content" v-html="details.content"></div>
  </div>
</template>

<script>
import { getBrowser } from "@/utils/browser";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";

const browser = getBrowser();

export default {
  data() {
    return {
      details: {}
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getHelpDetail();
  },
  beforeDestroy() {
    if (browser.isApp) {
      setStatementDetailInfo({
        headerTitle: this.$t("helpCenterNew.m00000")
      });
    }
  },
  methods: {
    getHelpDetail(){
      this.$apis.getHelpDetail({
        id: this.id,
      }).then((res) => {
        this.details = res;
        if (browser.isApp) {
          setStatementDetailInfo({
            headerTitle: res.title
          });
        } else {
          this.$store.commit("common/SAVE_NAV_TITLE", res.title);
        }
      })
    }
  }
}
</script>



<style scoped lang="less">
.help-center-new-details{
  padding: 28px 32px;
  font-size: 28px;
  .content{
    ::v-deep img{
      max-width: 100%;
      height: auto;
    }
  }
}
</style>